<template>
<div class="chapter">
<div class="inner_page">
<div id="ded">
<br/><br/><br/><br/><br/>
<p class="Body ParaOverride-2">I dedicate this book to my mom, an outlaw of the highest order. A true Renegade. You were right, it takes all kinds.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04ded.vue?2617b6df